function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var PokerStake = /*#__PURE__*/function () {
  function PokerStake() {
    _classCallCheck(this, PokerStake);
  }
  return _createClass(PokerStake, [{
    key: "initializeGameStake",
    value:
    //
    // initializes chips / pools / pots information
    //
    function initializeGameStake() {
      var crypto = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'CHIPS';
      var stake = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '100';
      console.log('Initialize Poker Stakes!');
      this.game.crypto = crypto;
      this.game.chips = 100;
      this.game.blind_mode = 'static';
      if (this.game.options.num_chips > 0) {
        this.game.chips = this.game.options.num_chips;
      }
      if (this.game.options.crypto) {
        this.game.crypto = this.game.options.crypto;
      }
      if (this.game.options.stake) {
        console.log('Analyzing game stake....');
        /*if (typeof this.game.options.stake == 'object') {
          let max = 0;
          for (let p in this.game.options.stake){
            console.log(p, this.game.options.stake[p]);
            if (this.game.options.stake[p] > max){
              max = this.game.options.stake[p];
              console.log(max);
            }
          }
          this.game.stake = max;
          this.game.staking_uneven = true;
        } else {*/
        this.game.stake = this.game.options.stake;
        //}
      } else {
        this.game.stake = stake;
      }
      if (this.game.options.blind_mode) {
        this.game.blind_mode = this.game.options.blind_mode;
      }
      this.game.state.round = 1;
      this.game.state.big_blind = 2;
      this.game.state.small_blind = 1;
      this.game.state.last_raise = this.game.state.big_blind;
      this.game.state.required_pot = this.game.state.big_blind;
      for (var i = 0; i < this.game.players.length; i++) {
        this.game.state.passed[i] = 0;
        this.game.state.player_pot[i] = 0;
        this.game.state.debt[i] = 0;
        this.game.state.player_credit[i] = this.game.chips;
      }
      this.game.queue = ['newround'];
    }
  }, {
    key: "returnTicker",
    value: function returnTicker() {
      if (this.game.crypto) {
        return this.game.crypto;
      }
      return 'CHIPS';
    }
  }, {
    key: "convertChipsToCrypto",
    value: function convertChipsToCrypto(numChips) {
      var asString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (this.returnTicker() == 'CHIPS' || _typeof(this.game.stake) == 'object') {
        return numChips;
      }
      var numCrypto = numChips * parseFloat(this.game.stake) / this.game.chips;
      if (asString) {
        var singleChipValue = String(parseFloat(this.game.stake / this.game.chips));
        var split_string = singleChipValue.split('.');
        var fraction = split_string[1] || '';
        var precision = fraction.length;
        return numCrypto.toFixed(precision);
      } else {
        return numCrypto;
      }
    }

    //
    // returns "1 CHIP" or "2.412 SAITO" or "1.423 CHIPS" etc.
    //
    // temporarily breaking this because we think CHIPS is always better...
    //
  }, {
    key: "formatWager",
    value: function formatWager(numChips) {
      var includeTicker = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      //let chips = this.game.crypto || 'CHIPS';
      var chips = 'CHIPS';
      if (chips === 'CHIPS') {
        if (numChips == 1) {
          chips = 'CHIP';
        }
      }
      var wager = '<span class="wager-num">' + numChips + '</span>';
      if (includeTicker) {
        wager += ' <span class="wager-ticker">' + chips + '</span>';
      }
      return wager;
    }

    //
    // returns "true" or "false" based on need to settle
    //
  }, {
    key: "needToSettleDebt",
    value: function needToSettleDebt() {
      var _this$game$options;
      if (!((_this$game$options = this.game.options) !== null && _this$game$options !== void 0 && _this$game$options.crypto)) {
        return false;
      }
      if (this.settle_every_hand) {
        return true;
      }
      //
      // if settleNow is true, the send/receive are added directly in the poker queue
      //
      if (this.settleNow) {
        return true;
      }
      if (this.toLeave.length > 0 || this.toJoin.length > 0) {
        return true;
      }
      for (var i = 0; i < this.game.state.player_credit.length; i++) {
        if (this.game.state.player_credit[i] <= 0) {
          return true;
        }
      }
      return false;
    }

    //
    // adds settlement instructions to queue for processing
    //
  }, {
    key: "settleDebt",
    value: function settleDebt() {
      if (_typeof(this.game.stake) == 'object') {
        console.info('Poker-stake: opt out of settleDebt function because asymmetrical betting');
        return;
      }
      for (var i = 0; i < this.game.state.debt.length; i++) {
        if (this.game.state.debt[i] > 0) {
          for (var j = 0; j < this.game.state.debt.length; j++) {
            if (this.game.state.debt[j] < 0) {
              var amount_owed = Math.min(Math.abs(this.game.state.debt[j]), this.game.state.debt[i]);
              if (amount_owed > 0) {
                this.game.state.debt[i] -= amount_owed;
                this.game.state.debt[j] += amount_owed;

                // Convert Chips to CRYPTO
                var amount_to_send = this.convertChipsToCrypto(amount_owed);
                this.addPaymentToQueue(this.game.players[i], this.game.players[j], amount_to_send);
              }
            }
          }
        }
      }
    }
  }, {
    key: "showStakeOverlay",
    value: function showStakeOverlay() {
      var _this = this;
      var html = "<div class=\"stake-info-overlay\"><div class=\"h3\">Game Stake</div>";
      var add_debt_button = false;
      html += "<div class=\"player-table\">";
      for (var i = 0; i < this.game.state.debt.length; i++) {
        html += "<div>".concat(this.app.keychain.returnUsername(this.game.players[i]), "</div>");
        var amount = typeof this.game.stake == 'string' ? this.game.stake : this.game.stake[this.game.players[i]];
        var status = 'has staked';
        if (this.game.crypto == 'CHIPS' || typeof this.game.stake == 'string') {
          if (this.game.state.debt[i] > 0) {
            add_debt_button = true;
            status = "owes";
            amount = this.convertChipsToCrypto(this.game.state.debt[i]);
          } else if (this.game.state.debt[i] < 0) {
            status = "is owed";
            amount = this.convertChipsToCrypto(-this.game.state.debt[i]);
          } else {
            var winnings = this.game.state.player_credit[i] + this.game.state.player_pot[i] - this.game.chips;
            if (winnings > 0) {
              status = "has won";
              amount = this.convertChipsToCrypto(winnings);
            } else if (winnings < 0) {
              status = "has lost";
              amount = this.convertChipsToCrypto(-winnings);
            }
          }
        }
        html += "<div>".concat(status, "</div><div>").concat(amount, " ").concat(this.game.crypto, "</div>");
      }
      html += '</div>';
      if (add_debt_button) {
        html += "<div class=\"saito-button-primary\" id=\"settle-now\">Settle</div>";
      }
      if (_typeof(this.game.stake) == 'object') {
        html += '<div>winner take all</div>';
      }
      html += '</div>';
      this.overlay.show(html);
      var db = document.querySelector('#settle-now');
      if (db) {
        db.onclick = function (e) {
          _this.sendMetaMessage('SETTLEMENT');
          _this.overlay.hide();
        };
      }
    }
  }]);
}();
module.exports = PokerStake;